import {createApp} from "vue";
import Certificate from "../vue/Certificate.vue";
import "../css/site.css";

export function BuyCertificate(options) {
    createApp(Certificate, options).mount('#js-form')
}
